'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxConnect = require('redux-connect');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _StatisticsSelectedRecipientInfo = require('components/Statistics/StatisticsSelectedRecipientInfo/StatisticsSelectedRecipientInfo');

var _StatisticsSelectedRecipientInfo2 = _interopRequireDefault(_StatisticsSelectedRecipientInfo);

var _statistics2 = require('selectors/statistics');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecipientStatistics = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadRecipients()).promise);
  }
}, {
  promise: function promise(_ref2) {
    var dispatch = _ref2.store.dispatch,
        recipientId = _ref2.params.recipientId,
        referrerRecipient = _ref2.location.query.referrerRecipient;
    return dispatch(statisticsActions.setRecipientId({ recipientId: Number(referrerRecipient || recipientId) }));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    recipientInfo: (0, _statistics2.getRecipientFromList)(state, Number(ownProps.location.query.referrerRecipient || ownProps.params.recipientId)),
    recipientInfoLoading: state.statistics.coverageStatsLoading
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RecipientStatistics, _Component);

  function RecipientStatistics() {
    (0, _classCallCheck3.default)(this, RecipientStatistics);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientStatistics.__proto__ || (0, _getPrototypeOf2.default)(RecipientStatistics)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientStatistics, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          component = _props.component,
          recipientInfo = _props.recipientInfo,
          recipientInfoLoading = _props.recipientInfoLoading;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_StatisticsSelectedRecipientInfo2.default, {
          recipient: recipientInfo,
          loading: recipientInfoLoading,
          showChangeButton: true
        }),
        component
      );
    }
  }]);
  return RecipientStatistics;
}(_react.Component), _class2.propTypes = {
  component: _propTypes2.default.node,
  recipientInfo: _propTypes2.default.object,
  recipientInfoLoading: _propTypes2.default.bool
}, _class2.defaultProps = {
  recipientInfo: {}
}, _temp)) || _class) || _class);
exports.default = RecipientStatistics;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/RecipientStatistics/RecipientStatistics.js
// module id = 2216
// module chunks = 1